import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { AiChat } from '../../@types';

type Payload = {
  chatId: string;
  shouldFetchData?: boolean;
};

const getAIChatById = async ({ chatId }: Payload): Promise<AiChat> => {
  const res = await axiosInstance.get(`/api/script/get-ai-chats/${chatId}`);
  return res.data;
};

export const useGetAiMediaById = (payload?: Partial<Payload>) => {
  const chatId = payload?.chatId;

  return useQuery(['getAiChatById', chatId], () => getAIChatById({ chatId: chatId as string }), {
    enabled: Boolean(chatId) && (payload?.shouldFetchData ?? true),
    keepPreviousData: true,
    staleTime: 60_000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
